import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { chakra, Flex, Image, Spacer } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';

import { CollectionDetailsRouteState, ToolboxCollection } from '../../types';
import locales from './locales';

const Link = chakra(RouterLink);

interface CollectionCardLinkProps {
  to: {
    pathname: string;
    state: CollectionDetailsRouteState;
  };
}

export const CollectionCardLink: FCWithChildren<CollectionCardLinkProps> = (
  props,
) => (
  <Link
    // needed to make all cards the same height on a grid
    display="flex"
    {...props}
  />
);

interface CollectionCardProps {
  collection: ToolboxCollection;
}

const CollectionCard: FC<CollectionCardProps> = ({ collection }) => (
  <Flex
    alignItems="center"
    backgroundColor="grey.200"
    backgroundSize="cover"
    borderRadius="radius-8"
    flexDirection="column"
    height="325px"
    paddingBottom="space-32"
    paddingTop="space-24"
    width="100%"
  >
    {collection.cardBg ? (
      <Image
        alt=""
        boxSize="145px"
        fit="cover"
        role="presentation"
        src={collection.cardBg}
      />
    ) : null}

    <Spacer />

    {collection.title ? (
      <Heading marginBottom="space-20" textAlign="center">
        {collection.title}
      </Heading>
    ) : null}

    <Button icon="arrow-right" variant="inline-secondary">
      {locales.discover}
    </Button>
  </Flex>
);

export default CollectionCard;
